/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, createElement } from 'react';
import clsx from 'clsx';

import { Typography } from 'omakase';
import { UnknownIcon } from '@tock/shared/components/icons/CreditCardIcons';
import CreditCardBrandMapping from '@tock/shared/constants/CreditCardBrandMapping';

interface Props {
  isSelected?: boolean;
  option: any;
}

const iconStyle = { fontSize: `2.4rem`, marginRight: `0.6rem` };

class CreditCardDropdownOption extends Component<Props> {
  static defaultProps: any;

  render() {
    const { isSelected, option } = this.props;

    if (option.value) {
      const { component, maskClass } =
        CreditCardBrandMapping[option.brand] || CreditCardBrandMapping.Unknown;
      const className = clsx('CreditCardDropdownOption', maskClass, {
        'is-selected': isSelected,
      });
      const iconComponent = createElement(component, {
        style: iconStyle,
      });

      return (
        <div className={className}>
          <Typography color="inherit" component="span" variant="body02">
            {iconComponent}
            <span className="CreditCardDropdownOption-mask CreditCardDropdownOption-maskOne">
              •••• •••••• •
            </span>
            <span className="CreditCardDropdownOption-mask CreditCardDropdownOption-maskTwo">
              •••• •••• ••••
            </span>
            <span className="CreditCardDropdownOption-lastFour">{option.maskedNumber}</span>
          </Typography>
        </div>
      );
    } else {
      const className = clsx('CreditCardDropdownOption', {
        'is-selected': isSelected,
      });

      return (
        <div className={className}>
          <UnknownIcon style={iconStyle} />
          <span className="CreditCardDropdownOption-placeholder">
            <Typography color="inherit" component="span" variant="body02">
              {option.label}
            </Typography>
          </span>
        </div>
      );
    }
  }
}
CreditCardDropdownOption.defaultProps = {
  isSelected: null,
};

export default CreditCardDropdownOption;
